import type { TFunction } from 'i18next';

/**
 * The predefined journal tags. The value is what the API stores (English, kept
 * for backwards compatibility with existing entries); the label is translated
 * at render time via journalTagLabel. Unknown (free-text) tags render as-is.
 */
export const JOURNAL_TAGS = [
  'New Coral',
  'ICP Results',
  'Maintenance',
  'Equipment',
  'Problem',
  'Milestone',
  'Fish',
  'Growth Update',
] as const;

const TAG_LABEL_KEYS: Readonly<Record<string, string>> = {
  'New Coral': 'journal.tagOptions.newCoral',
  'ICP Results': 'journal.tagOptions.icpResults',
  Maintenance: 'journal.tagOptions.maintenance',
  Equipment: 'journal.tagOptions.equipment',
  Problem: 'journal.tagOptions.problem',
  Milestone: 'journal.tagOptions.milestone',
  Fish: 'journal.tagOptions.fish',
  'Growth Update': 'journal.tagOptions.growthUpdate',
};

/** Translated label of a stored journal tag value. */
export function journalTagLabel(tag: string, t: TFunction): string {
  const key = Object.prototype.hasOwnProperty.call(TAG_LABEL_KEYS, tag)
    ? // eslint-disable-next-line security/detect-object-injection
      TAG_LABEL_KEYS[tag]
    : undefined;
  return key ? t(key) : tag;
}

/** Long, locale-aware calendar date (e.g. "9. Oktober 2026" in German). */
export function formatJournalDate(dateString: string, language: string | undefined): string {
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString(language || undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
